// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { CardCarouselCardFragmentDoc } from './CardCarouselCard.fragment.generated';
export const ComponentCardCarouselFragmentDoc = gql`
    fragment componentCardCarousel on ComponentCardCarousel {
  items {
    ...cardCarouselCard
  }
}
    ${CardCarouselCardFragmentDoc}`;